import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Dialog(theme: Theme): Components<Theme> {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dialog,
          "&.MuiPaper-rounded": {
            borderRadius: Number(theme.shape.borderRadius) * 2,
          },
          "&.MuiDialog-paperFullScreen": {
            borderRadius: 0,
          },
          [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(2),
          },
          [theme.breakpoints.down(664)]: {
            ".MuiDialog-scrollBody &.MuiDialog-paperWidthSm": {
              maxWidth: "100%",
            },
          },
        },
        paperFullWidth: {
          width: "100%",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(3),
          paddingRight: theme.spacing(3),
          paddingBottom: theme.spacing(0.5),
          paddingLeft: theme.spacing(3),
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(2),
          paddingRight: theme.spacing(3),
          paddingBottom: 0,
          paddingLeft: theme.spacing(3),
          // MUI sets paddingTop: 0 after DialogTitle, which clips outlined
          // labels. 0.5 + 1.5 = the original spacing(2) title-to-field gap.
          ".MuiDialogTitle-root + &&": {
            paddingTop: theme.spacing(1.5),
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
          "& > :not(:first-of-type)": {
            marginLeft: theme.spacing(1.5),
          },
        },
      },
    },
  };
}
